import { rec, toNumberOrNull } from './_helpers';

export type RecomputeStatus = 'pending' | 'running' | 'done' | 'failed';

export interface RecomputeJob {
  readonly id: number;
  readonly status: RecomputeStatus;
  readonly snapshotsCount: number | null;
  readonly startedAt: string | null;
  readonly finishedAt: string | null;
  readonly error: string | null;
}

const STATUSES: readonly RecomputeStatus[] = ['pending', 'running', 'done', 'failed'];

/** Mappe la réponse `/recompute/{id}` ou `/recompute/current`. `null` si pas de job actif. */
export function mapRecomputeJob(body: unknown): RecomputeJob | null {
  if (body === null || body === undefined) {
    return null;
  }
  const root = rec(body);
  const id = toNumberOrNull(root['id']);
  if (id === null) {
    return null;
  }
  const rawStatus = String(root['status'] ?? '');
  const status = (STATUSES as readonly string[]).includes(rawStatus)
    ? (rawStatus as RecomputeStatus)
    : 'pending';
  return {
    id,
    status,
    snapshotsCount: toNumberOrNull(root['snapshotsCount']),
    startedAt: root['startedAt'] ? String(root['startedAt']) : null,
    finishedAt: root['finishedAt'] ? String(root['finishedAt']) : null,
    error: root['error'] ? String(root['error']) : null,
  };
}
